// Import Material UI
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import { Close } from '@material-ui/icons'

// Import Packages
import React from 'react'
import { useTranslation } from 'react-i18next';
import { convertToDateFormat } from '../../../../../helpers/helper';

// Import Recoil
import { personalizationState } from '../../../../../recoil-store/recoil-state';
import { useRecoilValue } from 'recoil';

const NotificationsDetail = ({ openDetail, setOpenDetail, label, handleShowTitle }) => {
    const { t } = useTranslation();
    const personalization = useRecoilValue(personalizationState);
    return (
        <Dialog
            id="notification-detail-dialog"
            data-test="autom-add-new"
            className="autom-group"
            open={true}
            onClose={() => setOpenDetail(false)}
            PaperProps={{
                style: {
                    minWidth: "35%",
                    minHeight: "30%",
                    maxWidth: "95%",
                    borderRadius: " 4px",
                    padding: "4px 22px 40px 22px"
                },
            }}
        >
            <DialogTitle id="notification-dialog-title">
                <div id="about-title" className="add-group-header all-logs-header">
                    <h4 className="notifications-name-title">{t(label + "DETAILS")}</h4>
                    <Close className="autom-group-close-button logs-close-icon" onClick={() => setOpenDetail(false)} style={{ fontSize: "1rem" }} />
                </div>
            </DialogTitle>
            <DialogContent>
                <div className='db-detail-container'>
                    <div className='db-detail-header'>
                        <div className='db-detail-title-text'>{t(label + "TITLE")}</div>
                        <div className='db-detail-text'>{handleShowTitle(openDetail.title, false)}</div>
                    </div>
                    <div className='db-detail-header'>
                        <div className='db-detail-title-text'>{t(label + "DESCRIPTION")}</div>
                        <div className='db-detail-text'>{handleShowTitle(openDetail.description, true)}</div>
                    </div>
                    <div className='db-detail-header'>
                        <div className='db-detail-title-text'>{t(label + "TIME")}</div>
                        <div className='db-detail-text'>{convertToDateFormat(openDetail.created_at, personalization.date_format)}</div>
                    </div>
                </div>
            </DialogContent>

        </Dialog>
    )
}

export default NotificationsDetail